import React, { useState, useEffect, useCallback } from 'react';
import { Bubble, BubbleContentProps, Icon } from 'tea-component';
import classNames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';

import './index.scss';

interface Props {
  theme?: 'dark' | 'white';
  visible?: boolean | undefined; // 受控显示
  placement?: BubbleContentProps['placement']; // 冒泡提示位置
  isArrowPointAtCenter?: boolean;
  placementOffset?: any;
  DomOrText?: JSX.Element[] | JSX.Element | string; // 展示的文本
  customBubbleContent?: JSX.Element[] | JSX.Element | string | null; // 自定义气泡内容
  maxWidth?: number; // 气泡内容最大宽度，按规范是450px，此时当前属性为418
  style?: React.CSSProperties; // 文案样式
  className?: string;
  hasPointer?: boolean; // 是否要hover手型
  isClose?: boolean; // 关闭按钮
  onClose?: Function; // 关闭按钮事件
  [keyName: string]: any; // 其他参数
}

const DEFAULT_PROPS: Props = {
  theme: 'dark',
  visible: undefined,
  placement: 'top',
  placementOffset: 10,
  isArrowPointAtCenter: true,
  style: {},
  className: '',
  DomOrText: <Icon type="info" style={{ marginLeft: 4 }} />,
  customBubbleContent: null,
  maxWidth: 418,
  hasPointer: false,
  isClose: false,
  onClose: () => {},
};

function index(props: Props) {
  const {
    theme,
    visible: propsVisible,
    placement,
    placementOffset,
    isArrowPointAtCenter,
    DomOrText,
    customBubbleContent,
    maxWidth,
    style,
    className,
    hasPointer,
    isClose,
    onClose,
    ...others
  } = props;

  const [visible, setVisible] = useState<boolean | undefined>(undefined);

  const handleClose = useCallback(() => {
    setVisible(false);
    onClose?.();
  }, []);

  const bubbleContent = useCallback(() => {
    return (
      customBubbleContent && (
        <div className="dbg-common-bubble-inner">
          <div style={{ maxWidth }}>{customBubbleContent}</div>
          {isClose && (
            <i className="dbg-common-bubble-inner-close">
              <SvgIcon type="clonse" onClick={handleClose}></SvgIcon>
            </i>
          )}
        </div>
      )
    );
  }, [customBubbleContent]);

  const bubbleContentInfo = bubbleContent();

  useEffect(() => {
    setVisible(propsVisible);
  }, [propsVisible]);

  return (
    <Bubble
      className={classNames({
        'dbg-common-bubble': true,
        // 'bubble-all-bg': theme === 'dark',
        // 'bubble-all-bg-top': placement?.includes('top') && theme === 'dark',
        // 'bubble-all-bg-bottom': placement?.includes('bottom') && theme === 'dark',
        // 'bubble-all-bg-left': placement?.includes('left') && theme === 'dark',
        // 'bubble-all-bg-right': placement?.includes('right') && theme === 'dark',
        [className as string]: className,
      })}
      // destroyOnClose={false}
      dark={theme === 'dark'}
      visible={visible}
      arrowPointAtCenter={isArrowPointAtCenter}
      closeOnScroll
      placement={placement}
      content={bubbleContentInfo}
      placementOffset={placementOffset}
      {...others}
      // trigger={'click'}
    >
      <span
        className={hasPointer && customBubbleContent ? 'gp-cursor-pointer' : ''}
        style={style}
      >
        {DomOrText}
      </span>
    </Bubble>
  );
}

// props的默认值
index.defaultProps = DEFAULT_PROPS;

export default index;
